const addressTypes = {
  SHIPPING: "SHIPPING",
  BILLING: "BILLING",
};

export default addressTypes;
